import axios from 'axios';
import queryString from 'query-string';
import DataComplianceStatsResponse = App.Data.Response.DataComplianceStatsResponse;
import DataComplianceStatsRequest = App.Data.Request.DataComplianceStatsRequest;
import ListDataComplianceItinerariesResponse = App.Data.Response.ListDataComplianceItinerariesResponse;
import CountDataComplianceUserItinerariesResponse = App.Data.Response.CountDataComplianceUserItinerariesResponse;
import DataComplianceSettingsResponse = App.Data.Response.DataComplianceSettingsResponse;
import UpdateDataComplianceSettingsRequest = App.Data.Request.UpdateDataComplianceSettingsRequest;
import ListDataComplianceSourceModelsRequest = App.Data.Request.ListDataComplianceSourceModelsRequest;
import ListDataComplianceItinerariesRequest = App.Data.Request.ListDataComplianceItinerariesRequest;
import ListDataComplianceSourceModelsUsersResponse = App.Data.Response.ListDataComplianceSourceModelsUsersResponse;
import ListDataComplianceSourceModelsLegalEntitiesResponse = App.Data.Response.ListDataComplianceSourceModelsLegalEntitiesResponse;
import ListDataComplianceUserItinerariesResponse = App.Data.Response.ListDataComplianceUserItinerariesResponse;
import DataComplianceUserItinerariesRequest = App.Data.Request.DataComplianceUserItinerariesRequest;
import ListDataComplianceSourceModelItinerariesRequest = App.Data.Request.ListDataComplianceSourceModelItinerariesRequest;
import ListDataComplianceSourceModelItinerariesResponse = App.Data.Response.ListDataComplianceSourceModelItinerariesResponse;
import CountDataComplianceUserItinerariesRequest = App.Data.Request.CountDataComplianceUserItinerariesRequest;
import ListSelectableDataComplianceUserItinerariesRequest = App.Data.Request.ListSelectableDataComplianceUserItinerariesRequest;
import ListSelectableDataComplianceUserItinerariesResponse = App.Data.Response.ListSelectableDataComplianceUserItinerariesResponse;
import MarkSelectedDataComplianceUserItinerariesRequest = App.Data.Request.MarkSelectedDataComplianceUserItinerariesRequest;

export const getDataComplianceSummary = async (
	data: DataComplianceStatsRequest,
): Promise<DataComplianceStatsResponse> => {
	const response = await axios.get(`/climate-pro/data-compliance/stats?${queryString.stringify(data)}`);
	return response.data;
};

export const getDataCompliancePastItineraries = async (
	data: ListDataComplianceSourceModelsRequest,
): Promise<ListDataComplianceSourceModelsLegalEntitiesResponse | ListDataComplianceSourceModelsUsersResponse> => {
	const response = await axios.get(`/climate-pro/data-compliance/source-models?${queryString.stringify(data)}`);
	return response.data;
};

export const getTravelerItineraries = async (
	data: ListDataComplianceItinerariesRequest,
): Promise<ListDataComplianceItinerariesResponse> => {
	const response = await axios.get(
		`/climate-pro/data-compliance/booker/itineraries?${queryString.stringify(data, { skipNull: true })}`,
	);
	return response.data;
};

export const getSourceModelItineraries = async (
	data: ListDataComplianceSourceModelItinerariesRequest,
): Promise<ListDataComplianceSourceModelItinerariesResponse> => {
	const response = await axios.get(
		`/climate-pro/data-compliance/source-models/itineraries?${queryString.stringify(data, { skipNull: true })}`,
	);
	return response.data;
};

export const getUncompliantTripsNum = async (
	data: CountDataComplianceUserItinerariesRequest,
): Promise<CountDataComplianceUserItinerariesResponse> => {
	const response = await axios.get(
		`/my-climate/data-compliance/itineraries-count/user?${queryString.stringify(data, { skipNull: true })}`,
	);
	return response.data;
};

export const getUncompliantItineraries = async (
	data: DataComplianceUserItinerariesRequest,
): Promise<ListDataComplianceUserItinerariesResponse> => {
	const response = await axios.get(
		`/my-climate/data-compliance/itineraries/user?${queryString.stringify(data, { skipNull: true })}`,
	);
	return response.data;
};

export const getSelectableUncompliantItineraries = async (
	data: ListSelectableDataComplianceUserItinerariesRequest,
): Promise<ListSelectableDataComplianceUserItinerariesResponse> => {
	const response = await axios.get(
		`/my-climate/data-compliance/itineraries/selectable/user?${queryString.stringify(data, { skipNull: true })}`,
	);
	return response.data;
};

export const getDataComplianceSettings = async (): Promise<DataComplianceSettingsResponse> => {
	const response = await axios.get('/climate-pro/data-compliance/settings');
	return response.data;
};

export const setDataComplianceSettings = async (data: UpdateDataComplianceSettingsRequest | undefined) => {
	const response = await axios.patch('/climate-pro/data-compliance/settings', data);
	return response.data;
};

export const setItineraryCompliant = async (itineraryId: number, travelerId: number) => {
	const response = await axios.patch(
		`/my-climate/data-compliance/itineraries/mark-compliant?${queryString.stringify(
			{
				itineraryId,
				travelerId,
			},
			{ skipNull: true },
		)}`,
	);
	return response.data;
};

export const setSelectedItinerariesCompliant = async (
	data: MarkSelectedDataComplianceUserItinerariesRequest,
): Promise<void> => {
	await axios.patch('/my-climate/data-compliance/itineraries/mark-selected-compliant', data);
};
